import type { FC, PropsWithChildren } from 'react';
import { useContext, createContext, useState } from 'react';

export const StepperContext = createContext<{
  stepperData: {
    activeStep: number;
    manualChange: boolean;
    stepsOrder: string[];
    setActiveStep: (activeStep: number) => void;
    setManualChange: (manualChange: boolean) => void;
    setStepsOrder: (stepsOrder: string[]) => void;
  };
}>({
  stepperData: {
    setActiveStep: () => {},
    activeStep: 0,
    setManualChange: () => {},
    manualChange: false,
    stepsOrder: [],
    setStepsOrder: () => {},
  },
});

export const StepperProvider: FC<PropsWithChildren> = ({ children }) => {
  const [activeStep, setActiveStep] = useState(0);
  const [manualChange, setManualChange] = useState(false);
  const [stepsOrder, setStepsOrder] = useState<string[]>([]);

  return (
    <StepperContext.Provider
      value={{
        stepperData: {
          activeStep,
          setActiveStep,
          manualChange,
          setManualChange,
          stepsOrder,
          setStepsOrder,
        },
      }}
    >
      {children}
    </StepperContext.Provider>
  );
};

export const useStepperData = () => {
  const ctx = useContext(StepperContext);

  return {
    context: ctx,
  };
};
